import gql from 'graphql-tag';

export default gql`
  mutation productDeleteDiscountPrice($input: PricingInput!) {
    productDeleteDiscountPrice(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
